import React, { forwardRef } from "react";
import styled, { keyframes, css } from "styled-components";

// will-change: transform;
export const promoteLayer = css``;

interface IFadeContentsProps {
	$animatingOut?: boolean;
	$direction: "right" | "left";
	$duration: number;
	children: React.ReactNode;
}

const getFadeContainerKeyFrame = ({ $animatingOut: animatingOut, $direction: direction }: Readonly<IFadeContentsProps>) => {
	if (!direction) {
		return "none";
	}
	return keyframes`
  to {
    transform: translateX(0px);
    opacity: ${animatingOut ? 0 : 1};
  }
`;
};
const FadeContainer = styled.div<IFadeContentsProps>`
	${promoteLayer}
	animation-name: ${getFadeContainerKeyFrame};
	animation-duration: ${(props) => props.$duration}ms;
	animation-fill-mode: forwards;
	opacity: ${(props) => (props.$direction && !props.$animatingOut ? 0 : 1)};
	top: 0;
	left: 0;
`;

const FadeContents = forwardRef<HTMLDivElement, Readonly<IFadeContentsProps>>(
	({ children, $duration, $animatingOut: animatingOut, $direction: direction }, ref) => (
		<FadeContainer aria-hidden={animatingOut} $animatingOut={animatingOut} $direction={direction} $duration={$duration} ref={ref}>
			{children}
		</FadeContainer>
	)
);

export default FadeContents;
